import * as actionTypes from './actionTypes';

export const showSideNavigation = () => {
    return {
        type: actionTypes.SIDE_NAVIGATION_VISIBLE
    }
}

export const hideSideNavigation = () => {
    return {
        type: actionTypes.SIDE_NAVIGATION_HIDDEN
    }
}


// WEBPACK FOOTER //
// ./src/store/actions/navigation.js